/** Разбор текста поста так, как его показывает ВКонтакте. */

export type VkSegment =
  | { type: "text"; text: string }
  | { type: "mention"; text: string; href: string }
  | { type: "hashtag"; text: string }
  | { type: "url"; text: string; href: string };

const TOKEN_RE = /\[(club|public|id|event)(\d+)\|([^\]\n]+)\]|(#[\p{L}\p{N}_@]+)|(https?:\/\/[^\s<>()]+[^\s<>().,!?;:»"'])/gu;

export function tokenizeVkText(text: string): VkSegment[] {
  const out: VkSegment[] = [];
  let last = 0;
  for (const m of text.matchAll(TOKEN_RE)) {
    const idx = m.index ?? 0;
    if (idx > last) out.push({ type: "text", text: text.slice(last, idx) });
    if (m[1]) out.push({ type: "mention", text: m[3], href: `https://vk.com/${m[1]}${m[2]}` });
    else if (m[4]) out.push({ type: "hashtag", text: m[4] });
    else if (m[5]) {
      const href = m[5];
      out.push({ type: "url", href, text: href.length > 48 ? `${href.slice(0, 45)}…` : href });
    }
    last = idx + m[0].length;
  }
  if (last < text.length) out.push({ type: "text", text: text.slice(last) });
  return out;
}

/**
 * Где ВК сворачивает длинный пост («Показать полностью…»): примерно после 6 строк
 * или ~420 символов. Возвращает индекс обрезки или null, если пост короткий.
 */
export function vkCollapsePoint(text: string, maxLines = 6, maxChars = 420): number | null {
  const t = text.trimEnd();
  if (!t) return null;
  const lines = t.split("\n");
  if (lines.length <= maxLines + 1 && t.length <= maxChars + 60) return null;
  let chars = 0;
  for (let i = 0; i < lines.length; i++) {
    const next = chars + lines[i].length + 1;
    if (i >= maxLines || next > maxChars) {
      if (i < maxLines && next > maxChars) {
        // режем по слову внутри длинной строки
        const room = Math.max(0, maxChars - chars);
        const cut = lines[i].lastIndexOf(" ", room);
        return chars + (cut > 20 ? cut : room);
      }
      return Math.max(0, chars - 1);
    }
    chars = next;
  }
  return null;
}

/** Снимает разметку ВК для коротких анонсов (карточки, календарь). */
export function vkPlainText(text: string): string {
  return text.replace(/\[(?:club|public|id|event)\d+\|([^\]\n]+)\]/g, "$1");
}

/** Первые строки поста без рубрики — для карточек. */
export function postExcerpt(text: string, rubric = "", max = 220): string {
  let t = vkPlainText(text).trim();
  if (rubric && t.startsWith(rubric.trim())) t = t.slice(rubric.trim().length).trim();
  t = t
    .replace(/\n{2,}/g, "\n")
    .replace(/^#.*$/gm, "")
    .trim();
  return t.length > max ? `${t.slice(0, max - 1).trimEnd()}…` : t;
}
